import ApiService from '@/service/ApiService';
import { defineStore } from 'pinia';

const ROUTER_STORAGE_KEY = 'app_router_list';

export const useRouterStore = defineStore('router', {
    state: () => ({
        currentTitle: '',
        routerList: [], // JSON.parse(localStorage.getItem('routerList')) || [],
        isInitialized: false,
        error: null,
        currentPath: '/',
        cacheDuration: 5 * 60 * 1000 // 5분간 라우터 정보 유지
    }),
    getters: {
        getCurrentTitle: (state) => state.currentTitle,
        hasRouterInfo: (state) => state.routerList.length > 0
    },
    actions: {
        async fetchRouterItems(forceUpdate = false) {
            const now = Date.now();
            // 주석해제시 main.js에서 fetchRouterItems 호출할 경우 5분간 로컬 캐시 정보를 사용하지만 cacheDuration이 지날 경우 새로 최신화   현재는 새로고침시 라우터정보는 업데이트 하지않음
            // if ((!forceUpdate && this.lastFetched && now - localStorage.getItem('routerLastFetched')) || null < this.cacheDuration) {
            //     console.log('✅ 캐시된 라우터 정보 사용');
            //     return;
            // }

            this.error = null;
            const url = '/api/authorization/page';

            try {
                console.log('🔄 라우터 정보 갱신');
                const response = await ApiService.get(url);
                const data = response.data;
                const extractedRoutes = this.extractPageItems(data.data);
                // console.log(data);
                // console.log(extractedRoutes);
                this.setRouterList(Array.isArray(extractedRoutes) ? extractedRoutes : []);
                localStorage.setItem('routerLastFetched', now); // 마지막 갱신시간 저장
                this.isInitialized = true;
                return this.routerList;
            } catch (err) {
                console.error('Error Get MenuItems:', err.message);
                this.error = err.message;
                this.setRouterList([]);
                throw err;
            }
        },
        extractPageItems(items) {
            let pageItems = [];
            for (const item of items) {
                const componentPath = item.menu_item_url === '/' ? 'Dashboard' : item.menu_item_url.slice(1);
                pageItems.push({
                    path: item.menu_item_url,
                    name: item.menu_item_code,
                    meta: { title: item.menu_item_name },
                    componentPath: componentPath
                });

                if (item.children_menu_items && item.children_menu_items.length > 0) {
                    pageItems = pageItems.concat(this.extractPageItems(item.children_menu_items));
                }
            }
            return pageItems;
        },
        setRouterList(items) {
            this.routerList = items;
        },
        setCurrentTitle(title) {
            this.currentTitle = title;
        },
        setCurrentPath(path) {
            this.currentPath = path;
            localStorage.setItem('currentPath', path);
        },
        setInitialized(value) {
            this.isInitialized = value;
            if (!value) {
                this.setCurrentPath('/'); // 초기화 시 기본 경로로 설정
                localStorage.removeItem('currentPath');
            }
        },
        saveRouterListToStorage() {
            localStorage.setItem(ROUTER_STORAGE_KEY, JSON.stringify(this.routerList));
        },
        loadRouterListFromStorage() {
            const storedRouterList = localStorage.getItem(ROUTER_STORAGE_KEY);
            if (storedRouterList) {
                this.routerList = JSON.parse(storedRouterList);
                return true;
            }
            return false;
        }
    },
    persist: {
        enabled: true,
        strategies: [
            {
                key: 'router',
                storage: localStorage,
                paths: ['routerList', 'isInitialized']
            }
        ]
    }
});
